<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div id="contactHeader" class="page-name color-71aa3f">
                        Create Contact
                    </div>
                    <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backContactCreate">Back</button>
                </div>
                <div v-if="isDataEditable === true" >
                    <div class="admin-page-content">
                        <form id="contactform">
                            <div class="forms-container">
                                <div class="row no-margin">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                        <div class="alert alert-success" id="alertSuccess">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span>Contact Added Successfully</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                        <div class="alert alert-danger" id="alertSuccess">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span id="errorMsg"></span>
                                        </div>
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Customer</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <v-select v-model="customer_id" @change="changedValue" name="customer_id"
                                                      label="text" :filterable="false" :options="customerArr"
                                                      @search="onSearch"
                                                      v-validate="'required'"
                                                      placeholder="Select Customer">
                                                <template slot="no-options">
                                                    Search Customers...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="requiredstar">*</div>
                                            <span v-show="errors.has('customer_id')" class="help is-danger" v-if="errors.has('customer_id')"><font color="red">Customer is Required</font></span>
                                        </div>    
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Collector</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <span class="form-control">{{user_id.text}}</span>
                                        </div>
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>First Name</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="first_name" name="first_name" class="form-control"
                                                placeholder="Enter First Name" v-model="first_name" >
                                            <!--
                                            2023-04-24: removed mandatory property as requested
                                            <input type="text" id="first_name" name="first_name" class="form-control"
                                                   placeholder="Enter First Name" v-model="first_name" 
                                                   v-validate="'required'">
                                            <div class="requiredstar">*</div>
                                            <span v-show="errors.has('first_name')" class="help is-danger" v-if="errors.has('first_name')"><font color="red">First Name is Required</font></span>
                                            -->
                                        </div>    
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Last Name</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="last_name" name="last_name" class="form-control"
                                                   placeholder="Enter Last Name" v-model="last_name" >
                                        </div>
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Job Title</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="job_title" name="job_title" class="form-control"
                                                   placeholder="Enter Job title" v-model="job_title" >
                                        </div>
                                    </div>
                                    <div style="display: none;" class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Description</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <textarea name="description" id="description" rows="3"
                                                      class="form-control no-resize"
                                                      placeholder="Enter Description"
                                                      v-model="description"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Business Unit</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <v-select id="collector" v-model="assigned_to_business_id" 
                                                      @change="changedValue" 
                                                      name="assigned_to_business_id" 
                                                      label="text" :filterable="false" :options="businessArr" 
                                                      @search="onSearchBusinessUnit" 
                                                      v-validate="'required'"
                                                      placeholder="Select Business Unit">
                                                <template slot="no-options">
                                                    Search Business Units...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="requiredstar">*</div>
                                            <span v-show="errors.has('assigned_to_business_id')" class="help is-danger" v-if="errors.has('assigned_to_business_id')"><font color="red">Business Unit is Required</font></span>
                                        </div>
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Street</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="street_primary1" name="street_primary1" class="form-control"
                                                   placeholder="Enter Street" v-model="street_primary1" >
                                        </div>
                                    </div>
                                    <div style="display: none;"  class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Street2</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="street_primary2" name="street_primary2" class="form-control"
                                                   placeholder="Enter Street2" v-model="street_primary2" >
                                        </div>
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>City</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="city_primary" name="city_primary" class="form-control"
                                                   placeholder="Enter City" v-model="city_primary" >
                                        </div>
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>State</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="state_primary" name="state_primary" class="form-control"
                                                   placeholder="Enter State" v-model="state_primary" >
                                        </div>
                                    </div>
                                    <div style="display: none;" class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Country</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="country_primary" name="country_primary" class="form-control"
                                                   placeholder="Enter Country" v-model="country_primary" >
                                        </div>
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Postal Code</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="postal_code_primary" name="postal_code_primary" class="form-control"
                                                   placeholder="Enter Postal Code" v-model="postal_code_primary" >
                                        </div>
                                    </div>
                                    <div style="display: none;" class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Street Secondary</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="street_secondary1" name="street_secondary1" class="form-control"
                                                   placeholder="Enter Street Secondary" v-model="street_secondary1" >
                                        </div>
                                    </div>
                                    <div style="display: none;" class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Street2 Secondary</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="street_secondary2" name="street_secondary2" class="form-control"
                                                   placeholder="Enter Street2 Secondary" v-model="street_secondary2" >
                                        </div>
                                    </div>
                                    <div style="display: none;" class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>City Secondary</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="city_secondary" name="city_secondary" class="form-control"
                                                   placeholder="Enter City Secondary" v-model="city_secondary" >
                                        </div>
                                    </div>
                                    <div style="display: none;" class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>State Secondary</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="state_Secondary" name="state_Secondary" class="form-control"
                                                   placeholder="Enter State Secondary" v-model="state_Secondary" >
                                        </div>
                                    </div>
                                    <div style="display: none;" class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Country Secondary</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="country_secondary" name="country_secondary" class="form-control"
                                                   placeholder="Enter Country Secondary" v-model="country_secondary" >
                                        </div>
                                    </div>
                                    <div style="display: none;" class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Postal Code Secondary</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="postal_code_secondary" name="postal_code_secondary" class="form-control"
                                                   placeholder="Enter Postal Code Secondary" v-model="postal_code_secondary" >
                                        </div>
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Email</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="email_primary" name="email_primary" class="form-control"
                                                   placeholder="Enter Email" v-model="email_primary" 
                                                   v-validate="'email'">
                                            <!--v-validate="'required|email'">-->
                                            <span class="help is-danger" v-if="errors.first('email_primary')" v-show="email_primary != ''"><font color="red">Email Must Be A Valid Email</font></span>
                                            <!--<span class="help is-danger" v-if="errors.has('email_primary')" v-show="email_primary == ''"><font color="red">Email is Required</font></span>-->
                                            <!--<div class="requiredstar">*</div>-->
                                        </div>
                                    </div>
                                    <div style="display: none;"  class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Email Secondary</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="email_secondary" name="email_secondary" class="form-control"
                                                   placeholder="Enter Email Secondary" v-model="email_secondary"
                                                   v-validate="'email'">
                                            <span class="help is-danger" v-if="errors.first('email_secondary')" v-show="email_secondary != ''"><font color="red">Email Secondary Must Be A Valid Email</font></span>
                                        </div>
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Phone Number</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="phone_number_primary" name="phone_number_primary" class="form-control"
                                                   placeholder="Enter Phone Number" v-model="phone_number_primary" 
                                                   v-validate="'required'">
                                            <span class="help is-danger" v-if="errors.has('phone_number_primary')" v-show="phone_number_primary == ''"><font color="red">Phone Number is Required<br></font></span>
                                            <div class="requiredstar">*</div>
                                        </div>
                                    </div>
                                    <div style="display: none;" class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Phone Number Secondary</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="phone_number_secondary" name="phone_number_secondary" class="form-control"
                                                   placeholder="Enter Phone Number Secondary" v-model="phone_number_secondary">
                                        </div>
                                    </div>
                                    <div style="display: none;" class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Phone Number Secondary</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="phone_number_secondary" name="phone_number_secondary" class="form-control"
                                                   placeholder="Enter Phone Number Secondary" v-model="phone_number_secondary">
                                        </div>
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Fax</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="fax" name="fax" class="form-control"
                                                   placeholder="Enter Fax" v-model="fax">
                                        </div>
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Contact Status</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <v-select
                                                name="contactStatus"
                                                v-model="contactStatus"
                                                id="status" label="text"
                                                :options="contactStatusArr"
                                                :required="true"
                                                :value="contactStatus"
                                                v-validate="'required'"
                                                ></v-select>
                                            <div class="requiredstar">*</div>
                                            <span v-show="errors.has('contactStatus')" class="help is-danger" v-if="errors.has('contactStatus')"><font color="red">Contact Status is Required.</font></span>
                                        </div>
                                    </div>
                                    <div class="col-12 ">
                                        <div class="col-12 paddingleft0">
                                            <input id="addContactBtn" type="submit" value="Save" class="btn general-button btn-primary" v-on:click.prevent="AddContact()">
                                            <input id="addAndContinueContactBtn" type="submit" value="Save and Continue" class="btn general-button btn-primary" v-on:click.prevent="AddContact(flag='Save and Continue')">
                                            <input id="CancelContact" type="submit" value="Cancel" class="btn general-button btn-primary" v-on:click.prevent="backContactCreate">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <!--<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="card form-header-task">
                            <div class="header">
                                <h2 >
                                    Create Contact
                                </h2>
                            </div>

                            <div class="body full-task-main">
                                <form id="contactform">
                                    <div class="row clearfix" >
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="alert alert-danger hide" id="alertError">
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                <strong id="errorMsg" class="error"></strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix"></div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="button-demo">

                                        </div>
                                    </div>
                                    <div class="row clearfix"></div>
                                </form>
                            </div>
                        </div>
                    </div>-->
                </div>
                <div v-if="isDataEditable === false" >
                    <div class="admin-page-content">
                        <div class="col-md-12 error-detail-main forms-container">
                            <div class="error-template">
                                <h1>Oops!</h1>
                                <!--<h2>403</h2>-->
                                <div class="error-details">Sorry You can't Edit This Record...</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import index from "../../router";
    import EventBus from "../event-bus";
    import Vue from "vue";
    import FrontFooter from '@/components/partials/FrontFooter';
    import VeeValidate from "vee-validate";
    Vue.use(VeeValidate);
    import SessioMixin from '../../mixins/sessionmixin';
// import moment from 'moment'
    const Swal = require('sweetalert2');
    var segments = "";
    export default {
        name: "CreateContact",
        mixins: [SessioMixin],
        components: {
            'app-footer': FrontFooter,
        },
        data() {
            return {
                contactStatus: {value: '1', text: "Active"},
                contactStatusArr: [
                    {
                        value: '1', text: "Active"
                    },
                    {
                        value: '0', text: "Inactive"
                    }
                ],
                permissions: [],
                cantAccessPage: true,
                isLoggedIn: false,
                created_by: "",
                updated_by: "",
                customer_id: "",
                options: "",
                customerArr: [],
                first_name: "",
                last_name: "",
                description: "",
                job_title: "",
                fax: "",
                assigned_to_business_id: "",
                businessArr: [],
                user_id: "",
                userArr: [],
                isDataEditable: true,
                street_primary1: '',
                street_primary2: '',
                city_primary: '',
                state_primary: '',
                country_primary: '',
                postal_code_primary: '',
                street_secondary1: '',
                street_secondary2: '',
                city_secondary: '',
                state_Secondary: '',
                country_secondary: '',
                postal_code_secondary: '',
                email_primary: '',
                email_secondary: '',
                phone_number_primary: '',
                phone_number_secondary: '',
                customerId: 0,
            };
        },
        watch: {
            customer_id: function (customer_id) {
                var self = this;
                if (typeof (customer_id) == "undefined" || customer_id == null) {
                    self.user_id = {value: '', text: ''};
                } else {
                    if (customer_id == '') {
                        self.user_id = {value: '', text: ''};
                    } else {
                        $.ajax({
                            url: process.env.ROOT_API + "/get/customer/user",
                            type: "GET",
                            headers: {
                                Accept: "application/json",
                                "Access-Control-Allow-Origin": "*",
                                Authorization: "Bearer " + localStorage.getItem("api_token"),
                                "Access-Control-Allow-Headers":
                                        "Origin, Content-Type, Authorization,X-Requested-With",
                                "Cache-Control": "no-cache"
                            },
                            data: {
                                customer_id: customer_id.value
                            },
                            dataType: "json",
                            success: function (data) {
                                self.user_id = {value: data[0].value, text: data[0].text};
                                self.userArr = data;
                            },
                            error: function (jqXHR, exception) {
                                if (jqXHR.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    if (jqXHR.status == 401) {
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        self.$router.push("/login");
                                    }
                                    self.error = jqXHR.responseJSON.message;
                                }
                            }
                        });
                    }
                }
            }
        },
        beforeMount: function () {
            var app = this;
            var check = localStorage.getItem("api_token");
            //console.log('beforeMount');
            //console.log('beforeMount' + this.isLoggedIn);
            if (check != null) {
                app.isLoggedIn = true;
                //console.log('beforeMount' + this.isLoggedIn);
                app.getPermissions();
            }
        },
        mounted: function () {
            //console.log('mounted');
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            $(".removeActive").removeClass("active");
            if (segments[2] == 'update') {
                if (segments[4] != 0) {
                    $("#menucustomers").addClass("active");
                } else {
                    $("#menucontacts").addClass("active");
                }
            } else {
                //console.log(segments[3]);
                if (segments[3] != 0) {
                    $("#menucustomers").addClass("active");
                } else {
                    $("#menucontacts").addClass("active");
                }
            }
            // $("#menucontacts").addClass("active");
            var self = this;
            /*$(".datetimepicker").bootstrapMaterialDatePicker({
             // format: 'dddd DD MMMM YYYY - HH:mm',
             format: "MM/DD/YYYY HH:mm:ss",
             clearButton: true,
             weekStart: 1
             });*/

            $("#due_date").change(function () {
                self.due_date = $("#due_date").val();
            });
            /*$('#addAndContinueContactBtn').click(function () {
             self.due_date = "";
             });*/
            if (localStorage.getItem("menu_small") == "1") {
                self.menuSmall();
            } else {
                self.menuBig();
            }

            if (segments[2] == 'update') {
                if (segments[3]) {
                    self.showLoader();
                    self.loadContact();
                    // $("#addAndContinueContactBtn").prop('disabled',true);
                    $("#addAndContinueContactBtn").hide();
                    $("#addContactBtn").val("Update");
                    $("#contactHeader").text("Edit Contact");
                }
            } else {
                if (segments[3] != 0) {
                    self.customerId = segments[3];
                    self.loadCustomeradd();
                }
            }

            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit(
                        "logged-in",
                        false,
                        userJson["first_name"],
                        userJson["last_name"],
                        userJson["email"]
                        );
            }
            self.loadBusinessUnits();
        },
        methods: {
            loadCustomeradd() {
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/get/customers",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        default: self.customerId
                    },
                    dataType: "json",
                    success: function (data) {
                        self.customer_id = {value: data[0].value, text: data[0].text};
                        self.customersArr = data;
                        // console.log(self.customersArr.data());
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            getPermissions: function () {
                //console.log('getPermissions');
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_add_new_contact') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            changedValue: function (value) {
                //console.log(value);
            },

            onSearch(search, loading) {
                if (search.length > 2) {
                    loading(true);
                    this.loadCustomer(loading, search, this);
                }
            },
            onSearchUser(search, loading) {
                if (search.length > 2) {
                    loading(true);
                    this.loadUser(loading, search, this);
                }
            },
            onSearchBusinessUnit(search, loading) {
                if (search.length > 1) {
                    loading(true);
                    this.loadBusinessUnit(loading, search, this);
                }
            },
            loadCustomer(loading, search, vm) {
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/get/customers",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);

                        self.customerArr = data;

                        // console.log(self.customerArr.data());
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            loadUser(loading, search, vm) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get/users",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search,
                        type: 'collector',
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);

                        self.userArr = data;
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            loadBusinessUnit(loading, search, vm) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/getbusinessunits",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);

                        self.businessArr = data;
                        //console.log(self.businessArr);
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            loadBusinessUnits() {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/getbusinessunits",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    dataType: "json",
                    success: function (data) {
                        self.businessArr = data;
                        self.assigned_to_business_id = {'text': data[0].text, 'value': data[0].value};
                        //console.log(self.businessArr);
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            backContactCreate() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                if (segments[2] == 'update') {
                    if (segments[4] != 0) {
                        self.$router.push("/customer/view/" + segments[4]);
                    } else {
                        self.$router.push("/listcontacts");
                    }
                } else {
                    if (segments[3] != 0) {
                        self.$router.push("/customer/view/" + segments[3]);
                    } else {
                        self.$router.push("/listcontacts");
                    }
                }

                // self.$router.push("/listcontacts");
            },

            AddContact(flag) {
                this.$validator.validate().then(result => {
                    if (result) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        var self = this;
                        if (segments[2] == 'update') {
                            if (segments[3]) {
                                //console.log(segments[3]);
                                $("#addContactBtn").val("Updating ...");
                                $("#addContactBtn").prop("disabled", true);
                                // $("#addAndContinueCaseBtn").prop('disabled',true);
                                $("#CancelContact").prop("disabled", true);
                            } else {
                                if (flag == "Save and Continue") {
                                    $("#addAndContinueContactBtn").val("Saving ...");
                                    $("#addAndContinueContactBtn").prop("disabled", true);
                                    $("#addContactBtn").prop("disabled", true);
                                    $("#CancelContact").prop("disabled", true);
                                } else {
                                    $("#addContactBtn").val("Saving ...");
                                    $("#addContactBtn").prop("disabled", true);
                                    $("#addAndContinueContactBtn").prop("disabled", true);
                                    $("#CancelContact").prop("disabled", true);
                                }
                            }
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueContactBtn").val("Saving ...");
                                $("#addAndContinueContactBtn").prop("disabled", true);
                                $("#addContactBtn").prop("disabled", true);
                                $("#CancelContact").prop("disabled", true);
                            } else {
                                $("#addContactBtn").val("Saving ...");
                                $("#addContactBtn").prop("disabled", true);
                                $("#addAndContinueContactBtn").prop("disabled", true);
                                $("#CancelContact").prop("disabled", true);
                            }
                        }
                        var fields = $("#contactform").serializeArray();
                        fields.push({
                            name: "assigned_to_business_id",
                            value: self.assigned_to_business_id.value
                        });
                        fields.push({name: "status", value: self.contactStatus.value});
                        fields.push({name: "customer_id", value: self.customer_id.value});
                        fields.push({name: "user_id", value: self.user_id.value});
                        this.$validator.validateAll();
                        this.$validator.errors.clear();
                        if (segments[2] == 'update') {
                            if (segments[3]) {
                                fields.push({name: "id", value: segments[3]});
                            } else {
                                fields.push({name: "id", value: 0});
                            }
                        } else {
                            fields.push({name: "id", value: 0});
                        }
                        self.showLoader();
                        $.ajax({
                            url: process.env.ROOT_API + "/contact/create",
                            type: "POST",
                            data: fields,
                            headers: {
                                Accept: "application/json",
                                "Access-Control-Allow-Origin": "*",
                                Authorization: "Bearer " + localStorage.getItem("api_token"),
                                "Access-Control-Allow-Headers":
                                        "Origin, Content-Type, Authorization,X-Requested-With",
                                "Cache-Control": "no-cache"
                            },
                            dataType: "json",
                            success: function (data) {
                                self.hideLoader();
                                if (segments[2] == 'update') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addContactBtn").val("Update");
                                        $("#addContactBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelContact").prop("disabled", false);
                                        Swal.fire(
                                            'Updated!',
                                            'Contact updated successfully.',
                                            'success'
                                        )
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueContactBtn").val("Save and Continue");
                                            $("#addAndContinueContactBtn").prop("disabled", false);
                                            $("#addContactBtn").prop("disabled", false);
                                            $("#CancelContact").prop("disabled", false);
                                        } else {
                                            $("#addContactBtn").val("Save");
                                            $("#addContactBtn").prop("disabled", false);
                                            $("#addAndContinueContactBtn").prop("disabled", false);
                                            $("#CancelContact").prop("disabled", false);
                                            Swal.fire(
                                                'Updated!',
                                                'Contact updated successfully.',
                                                'success'
                                            )
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueContactBtn").val("Save and Continue");
                                        $("#addAndContinueContactBtn").prop("disabled", false);
                                        $("#addContactBtn").prop("disabled", false);
                                        $("#CancelContact").prop("disabled", false);
                                    } else {
                                        $("#addContactBtn").val("Save");
                                        $("#addContactBtn").prop("disabled", false);
                                        $("#addAndContinueContactBtn").prop("disabled", false);
                                        $("#CancelContact").prop("disabled", false);
                                        Swal.fire(
                                            'Added!',
                                            'Contact added successfully.',
                                            'success'
                                        )
                                    }
                                }
                                if (data.status == "success") {
                                    if (flag == "Save and Continue") {
                                        $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").parent().removeClass('hide');
                                        $(".alert-success").parent().addClass('show');

                                        self.assigned_to_business_id = "";
                                        self.description = "";
                                        self.contactStatus = "";
                                        self.customer_id = "";
                                        self.options = "";
                                        self.user_id = "";
                                        self.customerArr = [];
                                        self.userArr = [];
                                        self.first_name = "";
                                        self.last_name = "";
                                        self.job_title = "";
                                        self.fax = "";
                                        self.businessArr = [];
                                        self.street_primary1 = '';
                                        self.street_primary2 = '';
                                        self.city_primary = '';
                                        self.state_primary = '';
                                        self.country_primary = '';
                                        self.postal_code_primary = '';
                                        self.street_secondary1 = '';
                                        self.street_secondary2 = '';
                                        self.city_secondary = '';
                                        self.state_Secondary = '';
                                        self.country_secondary = '';
                                        self.postal_code_secondary = '';
                                        self.email_primary = '';
                                        self.email_secondary = '';
                                        self.phone_number_primary = '';
                                        self.phone_number_secondary = '';
                                        if (segments[3] != 0) {
                                            self.customerId = segments[3];
                                            self.loadCustomeradd();
                                        }
                                        self.loadBusinessUnits();
                                        setTimeout(function () {
                                            $(".alert-success").parent().removeClass('show');
                                            $(".alert-success").parent().addClass('hide');
                                        }, 5000);
                                    } else {
                                        self.backContactCreate();
                                    }
                                } else {
                                    // $(".alert-danger").parent().removeClass('hide');
                                    // $(".alert-danger").parent().addClass('show');
                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (segments[2] == 'update') {
                                    if (segments[3]) {
                                        $("#addContactBtn").val("Update");
                                        $("#addContactBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelContact").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        if (segments[3] != 0) {
                                            self.customerId = segments[3];
                                            self.loadCustomeradd();
                                        }
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueContactBtn").prop("disabled", false);
                                            $("#addAndContinueContactBtn").val("Save and Continue");
                                            $("#addContactBtn").prop("disabled", false);
                                            $("#CancelContact").prop("disabled", false);
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");

                                            self.assigned_to_business_id = "";
                                            self.description = "";
                                            self.contactStatus = "";
                                            self.customer_id = "";
                                            self.options = "";
                                            self.user_id = "";
                                            self.customerArr = [];
                                            self.userArr = [];
                                            self.first_name = "";
                                            self.last_name = "";
                                            self.job_title = "";
                                            self.fax = "";
                                            self.businessArr = [];
                                            self.street_primary1 = '';
                                            self.street_primary2 = '';
                                            self.city_primary = '';
                                            self.state_primary = '';
                                            self.country_primary = '';
                                            self.postal_code_primary = '';
                                            self.street_secondary1 = '';
                                            self.street_secondary2 = '';
                                            self.city_secondary = '';
                                            self.state_Secondary = '';
                                            self.country_secondary = '';
                                            self.postal_code_secondary = '';
                                            self.email_primary = '';
                                            self.email_secondary = '';
                                            self.phone_number_primary = '';
                                            self.phone_number_secondary = '';
                                            if (segments[3] != 0) {
                                                self.customerId = segments[3];
                                                self.loadCustomeradd();
                                            }
                                            self.loadBusinessUnits();
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addContactBtn").val("Save");
                                            $("#addContactBtn").prop("disabled", false);
                                            $("#addAndContinueContactBtn").prop("disabled", true);
                                            $("#CancelContact").prop("disabled", false);
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        }

                                        if (jqXHR.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (jqXHR.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueContactBtn").prop("disabled", false);
                                        $("#addAndContinueContactBtn").val("Save and Continue");
                                        $("#addContactBtn").prop("disabled", false);
                                        $("#CancelContact").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        if (segments[3] != 0) {
                                            self.customerId = segments[3];
                                            self.loadCustomeradd();
                                        }
                                        self.loadBusinessUnits();
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addContactBtn").val("Save");
                                        $("#addContactBtn").prop("disabled", false);
                                        $("#addAndContinueContactBtn").prop("disabled", true);
                                        $("#CancelContact").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }
                                }

                            }
                        });
                    }
                });
            },
            loadContact() {
                var path = window.location.pathname;
                segments = path.split("/");
                //console.log(segments[3]);
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/contact/show/" + segments[3],
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        if (data['contact'][0].data_source == 'manual')
                        {
                            self.description = data['contact'][0].description;
                            self.fax = data['contact'][0].fax;
                            self.job_title = data['contact'][0].job_title;
                            self.first_name = data['contact'][0].first_name;
                            self.last_name = data['contact'][0].last_name;
                            self.isDataEditable = true;
                            if (data['contact'][0].status) {
                                self.contactStatus = {
                                    value: data['contact'][0].status,
                                    text: 'Active'
                                }
                            } else {
                                self.contactStatus = {
                                    value: data['contact'][0].status,
                                    text: 'Inactive'
                                }
                            }
                            self.customer_id = {
                                value: data['contact'][0].cid,
                                text: data['contact'][0].cust_firstname + " (" + data['contact'][0].cusid + ")"
                            };
                            self.user_id = {
                                value: data['contact'][0].user_id,
                                text: data['contact'][0].user_firstname + " " + data['contact'][0].user_lastname /*+ " - " + data['contact'][0].user_email*/
                            };
                            self.assigned_to_business_id = {value: data['contact'][0].assigned_to_business_id, text: data['contact'][0].bu_home};

                            self.street_primary1 = data['contact_address'][0].street;
                            self.street_primary2 = data['contact_address'][0].street2;
                            self.city_primary = data['contact_address'][0].city;
                            self.state_primary = data['contact_address'][0].state;
                            self.country_primary = data['contact_address'][0].country;
                            self.postal_code_primary = data['contact_address'][0].postal_code;

                            self.street_secondary1 = data['contact_address'][0].street_2;
                            self.street_secondary2 = data['contact_address'][0].street2_2;
                            self.city_secondary = data['contact_address'][0].city_2;
                            self.state_Secondary = data['contact_address'][0].state_2;
                            self.country_secondary = data['contact_address'][0].country_2;
                            self.postal_code_secondary = data['contact_address'][0].postal_code_2;

                            self.email_primary = data['contact_details'][0].email_1;
                            self.email_secondary = data['contact_details'][0].email_2;
                            self.phone_number_primary = data['contact_details'][0].phone_1;
                            self.phone_number_secondary = data['contact_details'][0].phone_2;
                        } else {
                            self.isDataEditable = false;
                            //alert("Not Allow");
                            //self.$router.push("/listcontacts");
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            menuSmall: function () {
                $(".opensidebar").show();
                $(".closesidebar").hide();
                $(".menu").addClass("menusmall");
                $(".sidemenu li a span,.legal").addClass("displaynone");
                $(".sidemenu li a i").addClass("displayicons");
                $(".sidebar").css({width: "70px"});
                $(".content").css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $(".opensidebar").hide();
                $(".closesidebar").show();
                $(".menu").removeClass("menusmall");
                $(".sidemenu li a span,.legal").removeClass("displaynone");
                $(".sidemenu li a i").removeClass("displayicons");
                $(".sidebar").css({width: "260px"});
                $(".content").css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/contact/CreateContact.vue